import { JsonObject, JsonProperty } from 'json2typescript';

import { ContractDataInterface, IdInterface, ModelInterface } from '../../../core';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';

@JsonObject('ContractData')
export class ContractData implements ContractDataInterface {
    @JsonProperty('Valuation', Number, true)
    private _balance: number = undefined;

    @JsonProperty('ModelPortfolioId', IdAdapter, true)
    private _modelId: IdInterface = undefined;
    private _model: ModelInterface = undefined;

    constructor() {
        this._balance = 0;
    }

    get balance(): number {
        return this._balance;
    }

    get modelId(): IdInterface {
        return this._modelId;
    }

    get model(): ModelInterface {
        return this._model;
    }

    set model(value: ModelInterface) {
        this._model = value;
    }
}
